export const MATERIAL_GROUPS_ITEMS_PER_PAGE = 25;

export const MATERIAL_ARTICLE_SEARCH_MIN_LENGTH = 3;

export const INITIAL_MATERIAL_GROUP_FORM = {
  uuid: null,
  code: '',
  name: '',
  revision: null,
  articles: [],
};

export const GROUP_TEXTS = {
  title: 'Stock y compras | Grupos de materiales',
  add: 'Nuevo grupo',
  search: 'Buscar grupo',
  createTitle: 'Nuevo grupo de materiales',
  editTitle: 'Editar grupo de materiales',
  dataSection: 'Datos del grupo',
  membersSection: 'Integrantes',
  code: 'Código',
  name: 'Nombre',
  members: 'Integrantes',
  materials: 'Materiales',
  revision: 'Revisión',
  actions: 'Acciones',
  material: 'Material',
  articleSearch: 'Buscar artículo por código o nombre (desde 3 caracteres)',
  membersSummary: 'Integrantes',
  membersCount: (count) => `${count} ${count === 1 ? 'material' : 'materiales'}`,
  noMembers: 'Agregá al menos un material al grupo.',
  save: 'Guardar revisión',
  cancel: 'Cancelar',
  retry: 'Reintentar',
  edit: 'Editar grupo',
  remove: 'Desactivar grupo',
  removeMember: 'Quitar del grupo',
  empty: 'No se encontraron grupos de materiales.',
  loadError: 'No se pudieron cargar los grupos de materiales.',
  saveError: 'No se pudo guardar el grupo.',
  confirm: 'Desactivar grupo',
  confirmText: 'Desactivar',
  confirmMessage: (group) =>
    `¿Confirmás desactivar el grupo "${group?.name || ''}"? ` +
    'Los pedidos existentes conservarán su composición y nombres.',
};
